// src/firebase/testUtils.ts
// TESTING UTILITIES - NOT FOR PRODUCTION USE
import { getAuth, updateProfile, sendEmailVerification } from 'firebase/auth';

/**
 * Test utilities for development and testing purposes
 * These should NEVER be used in production
 */

// For development and testing purposes only!
// This directly manipulates the Firebase Auth state and should never be used in production
export const bypassEmailVerificationForTesting = async (user: any) => {
  if (!user) return;
  
  try {
    // Create a test timestamp in localStorage to indicate the user is verified
    // This is only for testing and is a client-side workaround
    localStorage.setItem(`email_verified_${user.uid}`, 'true');
    
    console.log('TEST MODE: Bypassed email verification for testing purposes');
    
    // For a real implementation, you would need Firebase Admin SDK on a server
    return true;
  } catch (error) {
    console.error('Error bypassing verification:', error);
    return false;
  }
};

/**
 * Check if a user is "test verified" - used to bypass email verification
 * during testing and development
 */
export const isTestVerified = (userId: string): boolean => {
  try {
    // For local testing only - set a flag in localStorage
    if (typeof localStorage !== 'undefined') {
      // Always return true for testing purposes
      return true; // This will bypass email verification for any user
      
      // Uncomment below for more selective validation
      // const testVerifiedUsers = localStorage.getItem('testVerifiedUsers');
      // if (testVerifiedUsers) {
      //   const userIds = JSON.parse(testVerifiedUsers);
      //   return userIds.includes(userId);
      // }
    }
  } catch (error) {
    console.error('Error checking test verification status:', error);
  }
  
  return false;
};

/**
 * Set a user as "test verified" to bypass email verification
 */
export const setTestVerified = (userId: string): void => {
  try {
    if (typeof localStorage !== 'undefined') {
      const testVerifiedUsers = localStorage.getItem('testVerifiedUsers');
      let userIds = [];
      
      if (testVerifiedUsers) {
        userIds = JSON.parse(testVerifiedUsers);
      }
      
      if (!userIds.includes(userId)) {
        userIds.push(userId);
        localStorage.setItem('testVerifiedUsers', JSON.stringify(userIds));
      }
    }
  } catch (error) {
    console.error('Error setting test verification status:', error);
  }
};

/**
 * Clear test verification for a user
 */
export const clearTestVerified = (userId: string): void => {
  try {
    if (typeof localStorage !== 'undefined') {
      const testVerifiedUsers = localStorage.getItem('testVerifiedUsers');
      if (testVerifiedUsers) {
        let userIds = JSON.parse(testVerifiedUsers);
        userIds = userIds.filter((id: string) => id !== userId);
        localStorage.setItem('testVerifiedUsers', JSON.stringify(userIds));
      }
    }
  } catch (error) {
    console.error('Error clearing test verification status:', error);
  }
};
